import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { add as addToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import { loadError, receive, setPriceRequestResponse } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch } from 'react-redux';
import { addToCartEvent } from "../Actions/Gtm.action";
const BuyButton = function ({ label, articleNumber, quantityFieldId, isQuotationProduct, href, cssClass, onClick, }) {
    return (_jsx(Fragment, { children: articleNumber ? (_jsx("a", { className: cssClass, onClick: (e) => {
                e.preventDefault();
                onClick({ articleNumber, quantityFieldId, isQuotationProduct });
            }, href: href || '#', rel: "nofollow", children: label })) : (_jsx("a", { className: cssClass, href: href || '#', rel: "nofollow", children: label })) }));
};
const StyledButton = (props) => {
    const dispatch = useDispatch();
    const onClick = async ({ articleNumber, quantityFieldId, isQuotationProduct }) => {
        try {
            const quantityElement = quantityFieldId ? document.getElementById(quantityFieldId) : null;
            const quantity = quantityElement && quantityElement.value
                ? parseInt(quantityElement.value, 10)
                : 1;
            const response = await addToCartService({ articleNumber, quantity, isQuotationProduct });
            await addToCartEvent(articleNumber, quantity);
            dispatch(receive(response.cart));
            if (response.message !== null) {
                dispatch(setPriceRequestResponse(response.message, articleNumber));
            }
            return true;
        }
        catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    };
    const Button = withReactiveStyleBuyButton(BuyButton, onClick, 'buy-button');
    return _jsx(Button, { ...props });
};
export default StyledButton;
